<div class="direction-input">
    <img src="../../../assets/icons/location-marker.svg" alt="" />
    <input id="address" [(ngModel)]="address" [placeholder]="placeholder" (input)="onInputChange()"
        autocomplete="off" />
    <ul *ngIf="suggestions.length > 0" class="autocomplete-suggestions">
        <li *ngFor="let suggestion of suggestions" (click)="onSuggestionSelected(suggestion)">
            {{ suggestion.description }}
        </li>
    </ul>
</div>